import { render } from "./publication_checkboxes.vue?vue&type=template&id=ae7df0d4&lang=pug"
import script from "./publication_checkboxes.vue?vue&type=script&lang=js"
export * from "./publication_checkboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__